/**
 * Politica de senha, como o servidor confere.
 *
 * So o comprimento. A dica antiga do convite prometia letras, numero e simbolo, e o
 * servidor nunca conferiu composicao: a tela prometia uma regra que nao existia. A
 * politica do OnPoint (de 4 a 20 caracteres com letras, numeros e especiais) e a
 * regra COR-001, pendente de decisao.
 */
export const POLITICA_DE_SENHA = 'Use de 12 a 256 caracteres.';
